<template>
    <b-row>
      <b-col cols="12">
        <b-card no-body class="card-statistics">
          <b-card-body class="statistics-body">
            <b-row class="align-items-center">
              <b-col cols="4"
                ><b-card-title class="mb-0"
                  >Campaigns Statistics</b-card-title
                ></b-col
              >
              <b-col
                v-for="item in statisticsItems"
                :key="item.icon"
                cols="4"
                class="mb-2 mb-md-0"
                :class="item.customClass"
              >
                <b-media no-body>
                  <b-media-aside class="mr-2">
                    <b-avatar size="48" :variant="item.color">
                      <feather-icon size="24" :icon="item.icon" />
                    </b-avatar>
                  </b-media-aside>
                  <b-media-body class="my-auto">
                    <h4 class="font-weight-bolder mb-0">
                      {{ item.title }}
                    </h4>
                    <b-card-text class="font-small-3 mb-0">
                      {{ item.subtitle }}
                    </b-card-text>
                  </b-media-body>
                </b-media>
              </b-col>
            </b-row>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
</template>

<script>
import VueApexCharts from "vue-apexcharts";
import axios from "@axios";
import {
  BRow,
  BCol,
  BCard,
  BCardGroup,
  BCardText,
  BCardHeader,
  BCardTitle,
  BCardBody,
  BMedia,
  BMediaAside,
  BAvatar,
  BMediaBody,
  BForm,
  VBTooltip,
  BButton,
  BContainer,
} from "bootstrap-vue";
export default {
  components: {
    BRow,
    BCol,
    BCard,
    BCardGroup,
    BCardText,
    BForm,
    BCardHeader,
    BCardTitle,
    BCardBody,
    BMedia,
    BMediaAside,
    BAvatar,
    BMediaBody,
    VBTooltip,
    BButton,
    BContainer,
    apexchart: VueApexCharts,
  },
  data() {
    return {
      totalVisits: null,
      clicks: null,
      statisticsItems: [
        // {
        //   icon: "TrendingUpIcon",
        //   color: "light-primary",
        //   title: "230k",
        //   subtitle: "Sales",
        //   customClass: "mb-2 mb-xl-0",
        // },
      ],

      accounts: [],
    };
  },
  mounted() {
    this.getCampaignTotalVisits();
    // this.getAccountsStatistics();
  },
  created() {},
  methods: {
    getCampaignTotalVisits() {
      this.$store
        .dispatch("appsManager/getAllCampaigns")
        .then(({ data }) => {
          data.campaigns.forEach((el) => {
            this.totalVisits += el.views;
            this.clicks += el.clicks;
          });
          this.statisticsItems.push({
            icon: "EyeIcon",
            color: "light-success",
            title: this.totalVisits,
            subtitle: "Total Views",
            customClass: "mb-2 mb-xl-0",
          });
          this.statisticsItems.push({
            icon: "MousePointerIcon",
            color: "light-primary",
            title: this.clicks,
            subtitle: "Total Clicks",
            customClass: "mb-2 mb-xl-0",
          });
        })
        // .catch(console.error);
    },
    getAccountsStatistics() {
      axios
        .get("/get-accounts-statistics")
        .then((response) => response.data)
        .then((data) => {
          this.accounts = data.accounts;
        })
        .catch(console.error);
    },
    redirectTo(account) {
      this.$router.push({
        name: "statistics-account",
        params: { account },
      });
    },
  },
};
</script>

<style lang="scss">
</style>
